import * as zod from "zod";
import type {ClassificacaoArtigoVm} from "@/modules/artigo/type/classificacaoArtigo.type";

// Mantido só pelo masterdata genérico "unidade" (UnidadeCtx) consumido pelo pedidoCompra
// (ver masterdataMap.ts) — o Artigo não usa mais esse vínculo, unidade dele é texto livre.
export interface UnidadeVm {
    unidadeId: number;
    descricaoUnidade: string;
    sigla: string;
}

export const zodUnidadeVm = zod.object({
    unidadeId: zod.number(),
    descricaoUnidade: zod.string(),
    sigla: zod.string(),
}, {message: "Selecione uma unidade"}).refine((val) => val != null);

export enum EStatusArtigo {
    Ativo = 1,
    Inativo = 2,
}

export interface ArtigoVm {
    id: number;
    codigo: string;
    codigoCompleto: string;
    descricao: string;
    descricaoComplementar: string | null;
    unidade: string;
    classificacaoArtigo: ClassificacaoArtigoVm;
    status: EStatusArtigo;
    statusDescricao: string;
    controlaEstoque: boolean;
    estoqueMinimo: number;
    estoqueMaximo: number;
    estoqueAtual: number;
}

export const zodArtigoVm = zod.object({
    id: zod.number(),
    codigoCompleto: zod.string(),
    descricao: zod.string(),
}, {message: "Selecione um artigo"}).refine((val) => val != null);

/**
 * Item de artigo/listar/catalogo — payload enxuto (classificação achatada, sem o objeto
 * ClassificacaoArtigoVm aninhado) pensado para lista longa/paginada (ver ARTIGO_CATALOGO_BUSCA.md).
 */
export interface ArtigoCatalogoItemVm {
    id: number;
    codigoCompleto: string;
    descricao: string;
    unidade: string;
    classificacaoArtigoId: number;
    classificacaoArtigoDescricao: string;
    classificacaoArtigoCor: string;
    estoqueAtual: number;
}

export interface ArtigoCatalogoResultVm {
    itens: ArtigoCatalogoItemVm[];
    total: number;
    pagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
}
